import { render, staticRenderFns } from "./fooote.vue?vue&type=template&id=c62d84b4&scoped=true&"
var script = {}
import style0 from "./fooote.vue?vue&type=style&index=0&id=c62d84b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62d84b4",
  null
  
)

export default component.exports